// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RenderSwal__defaults___LQ3w7 {
    font-size: 14px;
    border-radius: 25px ​ !important;
    color: white;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaults": `RenderSwal__defaults___LQ3w7`
};
module.exports = ___CSS_LOADER_EXPORT___;
